import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import { switchModule } from "../../../actions/display.js";
import { dp } from "../../../utils/shared.js";
import NavBlockOmaha from "./NavBlockOmaha";

class NavOmaha extends Component {
  constructor(props) {
    super(props);
    this._menuModules = _.filter(this.props.content.dm_active, function (dm) {
      return dm.module_contents.in_navigation;
    });

    this._background = null;
    this._arrow = null;
    this._logo = null;
    this._handIconRef = null;
    this._animateHandIntervalHandler = null;

    this.initializeAssets();

    this.state = {
      initializedRefs: false,
      animationName: ""
    };
    this.navRefs = [];
  }

  handleNav = (route) => {
    this.props.switchModule(route.module.id);
    this.props.navRoute(route.navLocation, route.module);
  };

  componentDidMount() {
    this.initializeNavRefs();
    this.animateHandInterval();
  }

  componentWillUnmount() {
    clearTimeout(this._animateHandIntervalHandler);
    for (let a = 0; a < this.navRefs.length; a++) {
      if (this.navRefs[a].el) {
        this.navRefs[a].el.removeEventListener("click", () => this.handleNav(this.navRefs[a].data));
      }
    }
  }

  initializeNavRefs = () => {
    if (this.state.initializedRefs === false) {
      for (let a = 0; a < this.navRefs.length; a++) {
        this.navRefs[a].el.addEventListener("click", () => this.handleNav(this.navRefs[a].data));
      }
      this.setState({
        initializedRefs: true
      });
    }
  };

  initializeAssets = () => {
    let assets = _.find(this.props.content.dm_active, function (o) {
      return o.name.includes("Assets");
    });
    if (!assets) {
      console.log("assets Slideshow Module was not found");
    }
    let backgroundIndex = _.indexOf(assets.contents.names, "Main Screen");
    let backgroundImage = assets.contents.images[backgroundIndex];

    let defaultBackground = { path: "/img/omaha/general/", file_name: "main-background.jpg" };
    this._background = dp(this.props.screen, backgroundImage, defaultBackground);
  };

  animateHandInterval = () => {
    clearTimeout(this._animateHandIntervalHandler);
    this._animateHandIntervalHandler = setTimeout(() => {
      this._handIconRef.animate(
        [
          {
            transform: "translateY(0%)"
          },
          {
            transform: "translateY(-25%)"
          },
          {
            transform: "translateY(-75%)"
          },
          {
            transform: "translateY(-25%)"
          },
          {
            transform: "translateY(0%)"
          },
          {
            transform: "translateY(-25%)"
          },
          {
            transform: "translateY(0%)"
          }
        ],
        {
          fill: "forwards",
          duration: 500
        }
      );
      this.animateHandInterval();
    }, 15000);
  };

  prepareMenuNavigation() {
    let location = [];
    let modules = [];

    return this._menuModules.map((row, i) => {
      // Check the number of story modules attached
      const storyModules = this.props.content.folder_modules
        .filter((fm) => fm.model === "story" && Number(fm.folder) === Number(row.contents.folder))
        .map((fm) => {
          const story = this.props.content.stories.find((st) => st.id === Number(fm.module_id));
          return {
            ...story,
            folder_module_id: fm.id
          };
        });

      // Attempt to get story_categories (folders) children of the one associated with the module
      const storyCategories = this.props.content.story_categories.filter(
        (sc) => Number(sc.parent_category) === Number(row.contents.folder)
      );

      const storyCategoriesAndStoriesCount = storyCategories.length + storyModules.length;

      if (storyCategoriesAndStoriesCount > 1) {
        location[i] = "/omaha/stories";
        row.currentSlide = 0;
        modules[i] = row;

        if (this._handIconRef) {
          this._handIconRef.addEventListener("click", () =>
            this.handleNav({
              navLocation: location[i],
              module: modules[i],
              stories: storyModules,
              categories: storyCategories
            })
          );
        }
      } else if (storyCategoriesAndStoriesCount === 1) {
        if (storyCategories.length === 1) {
          location[i] = "/omaha/recognition_list";
          modules[i] = storyModules[0];
          modules[i].display_module_id = row.id;
        } else {
          location[i] = `/omaha/story?id=${storyModules[0].folder_module_id}`;
          modules[i] = row;
          modules[i].display_module_id = row.id;
        }
      }

      let marginLeft = i === 0 ? "0px" : "1.2vh";
      if (this._menuModules.length === 1) {
        marginLeft =
          this.props.screen.screenWidth / 2 -
          (this.props.screen.screenHeight * 7.52344) / 100 -
          (this.props.screen.screenHeight * 20) / 100 / 2;
      }
      let background = "#8c827a";
      if (i === 0 || i % 2 === 0) {
        background = "#7a6e66";
      }

      return (
        <div key={i}>
          <div
            ref={(el) =>
              (this.navRefs[i] = {
                el: el,
                data: { navLocation: location[i], module: modules[i], stories: storyModules }
              })
            }
          >
            <NavBlockOmaha
              background={background}
              handleNav={this.handleNav}
              icon={dp(this.props.screen, row.module_contents.icon)}
              marginLeft={marginLeft}
              title={row.name}
            />
          </div>
        </div>
      );
    });
  }

  render() {
    const textShadow = "0.30vh 0.30vh 0.54vh rgba(51, 51, 51, 0.76)";
    const backgroundSize = `${this.props.screen.screenWidth}px ${this.props.screen.screenHeight}px`;
    return (
      <div
        style={{
          height: this.props.screen.r9_16.height,
          textAlign: "center",
          width: "100%",
          backgroundSize: backgroundSize,
          backgroundImage: "url(" + this._background + ")"
        }}
      >
        <div
          ref={(el) => (this._handIconRef = el)}
          style={{ position: "absolute", top: "92vh", width: "100%", height: "5vh" }}
        >
          <div style={{ width: "100%", height: "2vh", bottom: "47vh", position: "absolute" }}>
            <span style={{ textShadow: textShadow, fontSize: "2.5vh", fontWeight: "bold" }}>FIND OUT MORE</span>
          </div>
          <div style={{ position: "absolute", width: "100%", height: "16.58vh", bottom: "28vh" }}>
            <img
              className="shadowed-image"
              style={{ width: "16.58vh", height: "16.58vh" }}
              src={dp(this.props.screen, null, { path: "/img/ui/", file_name: "handicon-03.png" })}
              alt=""
            />
          </div>
        </div>
        <div style={{ left: "7.5234375vh", position: "absolute", bottom: "4.82vh", height: "20vh", width: "100%" }}>
          {this.prepareMenuNavigation()}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    switchModule: (id) => dispatch(switchModule(id))
  };
};

export default connect(null, mapDispatchToProps)(NavOmaha);



// WEBPACK FOOTER //
// ./src/Components/Theme/Omaha/NavOmaha.jsx